<template>
	<div v-if="dataisload" class="slide-main-block row">
		<div class="col-12 d-lg-none">
			<a class="back-shop-btn" @click.prevent="goBackPage" href="#">
				<i class="icon-back-shop"></i>
				<span>Back To The Shop</span>
			</a>
		</div>
		<div class="col-12 col-md-9">
			<Slick
				v-if="selectedProductImg.length > 0"
				class="slider-for slide-main"
				ref="slick"
				:options="slideOpts"
				@afterChange="handleAfterChange"
				@beforeChange="handleBeforeChange"
				@breakpoint="handleBreakpoint"
				@destroy="handleDestroy"
				@edge="handleEdge"
				@init="handleInit"
				@reInit="handleReInit"
				@setPosition="handleSetPosition"
				@swipe="handleSwipe"
				@lazyLoaded="handleLazyLoaded"
				@lazyLoadError="handleLazeLoadError"
			>
				<div @click="zoomPic(index)" class="photo-nav-item" v-for="(image, index) in selectedProductImg" :key="index">
					<i
						v-if="image.VideoUrl"
						class="icon-play d-md-inline-block d-none"
						style="
							position: absolute;
							top: 50%;
							left: 50%;
							margin-top: -30px;
							margin-left: -30px;
							background-size: 60px;
							background-position: center;
							z-index: 1;
						"
					></i>
					<i
						v-if="image.VideoMUrl"
						class="icon-play d-md-none d-inline-block"
						style="
							position: absolute;
							top: 50%;
							left: 50%;
							margin-top: -30px;
							margin-left: -30px;
							background-size: 60px;
							background-position: center;
							z-index: 1;
						"
					></i>
					<new-image :url="image.Url" :size="'_w594_h891'" :name="alldatas.Name"></new-image>
					<!--<img src="https://via.placeholder.com/594x891/808080/808080" alt="" />-->
				</div>
			</Slick>
		</div>
		<div class="col-12 col-md-3">
			<div class="slide-nav-block">
				<Slick
					v-if="selectedProductImg.length > 0"
					class="slider-nav slide-sub"
					:class="{ 'set-bottom': selectedProductImg.length < 5 }"
					ref="slickNav"
					:options="slideNavOpts"
					@afterChange="handleAfterChange"
					@beforeChange="handleBeforeChange"
					@breakpoint="handleBreakpoint"
					@destroy="handleDestroy"
					@edge="handleEdge"
					@init="handleInit"
					@reInit="handleReInit"
					@setPosition="handleSetPosition"
					@swipe="handleSwipe"
					@lazyLoaded="handleLazyLoaded"
					@lazyLoadError="handleLazeLoadError"
				>
					<div
						class="photo-nav-item hover-effect fade-effect"
						v-for="(image, index) in selectedProductImg"
						:key="selectedProductImg.length + index"
					>
						<new-image :url="image.Url" :size="'_w89_h134'" :name="alldatas.Name"></new-image>
						<!--<img src="https://via.placeholder.com/594x891/808080/808080" alt="" />-->
					</div>
				</Slick>
			</div>
		</div>
	</div>
</template>

<script>
import NewImage from "@global/components/global/image";
import Slick from "@global/vendors/vue-slick";
import zoomBox from "@global/components/product_vue/zoombox";
import imgTransfer from "@global/helpers/imgTransfer";
import setEnv from "@global/helpers/setEnv";

export default {
	name: "Photo",
	props: ["selected", "alldatas", "dataisload", "nowslideindex", "changeImage"],
	components: {
		NewImage,
		Slick,
	},
	data() {
		return {
			slideOpts: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				asNavFor: ".slider-nav",
				fade: true,
			},
			slideNavOpts: {
				slidesToShow: 6,
				slidesToScroll: 1,
				asNavFor: ".slider-for",
				dots: false,
				focusOnSelect: true,
				arrows: true,
				vertical: true,
				verticalSwiping: false,
				infinite: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							vertical: false,
							slidesToShow: 4,
							slidesToScroll: 1,
							infinite: true,
							arrows: true,
							dots: false,
						},
					},
				],
			},
		};
	},
	mounted() {
		// $(".slide-main-block").hide();
		// const _this = this;
		// this.$refs.slickNav.destroy();
		// if (this.slideNavOpts.length !== 0) {
		//   this.$refs.slickNav.create(this.slideNavOpts);
		// }
		// $(".slide-main-block").fadeIn();
		// setTimeout(() => {
		//   _this.$refs.slickNav.destroy();
		//   if (_this.slideNavOpts.length !== 0) {
		//     _this.$refs.slickNav.create(_this.slideNavOpts);
		//   }
		//   $(".slide-main-block").fadeIn();
		// }, 1000);
	},
	computed: {
		selectedProductImg: function () {
			let images = [];
			this.selected.Images.forEach(function (element, index) {
				if (element.Category === 0) images.push(element);
			});
			return images;
		},
	},
	methods: {
		goBackPage() {
			let searchStr = "hotgirldiscount";
			let localTest = "localhost";
			let lastUrlArray = document.referrer;
			if (lastUrlArray.indexOf(searchStr) !== -1 || lastUrlArray.indexOf(localTest) !== -1) {
				window.history.back();
			} else {
				window.location.href = "/";
			}
		},
		zoomPic(index) {
			let datas = [];

			this.selected.Images.forEach(function (element, index) {
				if (element.Category === 0) datas.push(element);
			});

			const new_datas = datas.map((ele, index) => {
				if (ele.VideoUrl.length !== 0 || ele.VideoMUrl.length !== 0) {
					// 有影片
					return setEnv.myEquipment()
						? imgTransfer(ele.VideoMUrl.length !== 0 ? ele.VideoMUrl : ele.Url, "")
						: imgTransfer(ele.VideoUrl.length !== 0 ? ele.VideoUrl : ele.Url, "");
				} else {
					return imgTransfer(ele.Url, "");
				}
			});

			console.log(new_datas);

			zoomBox({
				images: JSON.parse(JSON.stringify(new_datas)),
				index: index,
				yPos: event.pageY - window.scrollY,
				tilting: true,
			});
		},
		next() {
			this.$refs.slick.next();
		},

		prev() {
			this.$refs.slick.prev();
		},

		reInit() {
			// Helpful if you have to deal with v-for to update dynamic lists
			this.$nextTick(() => {
				this.$refs.slick.reSlick();
				this.$refs.slickNav.reSlick();
			});
		},
		// Events listeners
		handleAfterChange(event, slick, currentSlide) {
			// console.log('handleAfterChange', event, slick, currentSlide);
		},
		handleBeforeChange(event, slick, currentSlide, nextSlide) {
			// console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
		},
		handleBreakpoint(event, slick, breakpoint) {
			// console.log('handleBreakpoint', event, slick, breakpoint);
		},
		handleDestroy(event, slick) {
			// console.log('handleDestroy', event, slick);
		},
		handleEdge(event, slick, direction) {
			// console.log('handleEdge', event, slick, direction);
		},
		handleInit(event, slick) {
			// console.log('handleInit', event, slick);
		},
		handleReInit(event, slick) {
			// console.log('handleReInit', event, slick);
		},
		handleSetPosition(event, slick) {
			// console.log('handleSetPosition', event, slick);
		},
		handleSwipe(event, slick, direction) {
			// console.log('handleSwipe', event, slick, direction);
		},
		handleLazyLoaded(event, slick, image, imageSource) {
			// console.log('handleLazyLoaded', event, slick, image, imageSource);
		},
		handleLazeLoadError(event, slick, image, imageSource) {
			// console.log('handleLazeLoadError', event, slick, image, imageSource);
		},
	},
	beforeUpdate() {
		if (this.changeImage) {
			$(".slide-main-block").hide();
			this.$refs.slick.destroy();
			this.$refs.slickNav.destroy();
		}
	},
	updated() {
		var _this = this;
		if (this.changeImage) {
			setTimeout(function () {
				_this.$nextTick(function () {
					$(".slide-main-block").fadeIn();
					if (_this.slideOpts.length !== 0) {
						_this.$refs.slick.create(_this.slideOpts);
					}
					if (_this.slideNavOpts.length !== 0) {
						_this.$refs.slickNav.create(_this.slideNavOpts);
					}
				});
			}, 100);
		}
	},
};
</script>

<style></style>
